export const BASE_URL = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}`;
export const API_URL = `${BASE_URL}/api`;
export const OTP_URL = `${BASE_URL}/otp`;
export const CLOVER_URL = `${BASE_URL}/clover`;
